import { Link } from 'react-router-dom';

const legalLinks = [
  { to: '/privacy-policy', label: 'Privacy Policy' },
  { to: '/terms-of-service', label: 'Terms of Service' },
  { to: '/disclaimer', label: 'Disclaimer' },
  { to: '/contact', label: 'Contact' },
];

export default function Footer() {
  return (
    <footer className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 mt-12 transition-colors duration-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-sm text-gray-500 dark:text-gray-400">
            © {new Date().getFullYear()} Option View. All rights reserved.
          </div>
          <nav className="flex flex-wrap justify-center gap-x-4 gap-y-2">
            {legalLinks.map(({ to, label }) => (
              <Link
                key={to}
                to={to}
                className="text-sm text-gray-500 dark:text-gray-400 hover:text-blue-700 dark:hover:text-blue-400 transition-colors"
              >
                {label}
              </Link>
            ))}
          </nav>
        </div>
        <div className="mt-4 text-xs text-gray-400 dark:text-gray-500 text-center">
          Data sourced from multiple, free, publicly available sources. Updated daily at 6:30 PM IST.{' '}
          <strong>Not financial advice.</strong>{' '}
          <Link to="/disclaimer" className="underline hover:text-gray-600 dark:hover:text-gray-300">
            Read full disclaimer
          </Link>
          .
        </div>
      </div>
    </footer>
  );
}
